import OrderProductList from '../components/OrderProductList';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCustomerOrders } from '../hooks/useCustomerOrders';
import { getCustomer } from '../services/customerService';
import { customerOrderError, customerOrderStatusLabel, getOrderId, getOrderItems, orderDate, orderGrandTotal } from '../utils/orderPresentation';
import './customerOrders.css';

function CustomerOrdersPage() {
  const navigate = useNavigate();
  const hasSession = Boolean(getCustomer() && localStorage.getItem('customerAccessToken'));
  const query = useCustomerOrders(hasSession);
  if (!hasSession) return <div className="orders-page"><div className="orders-empty"><h1>Мои заказы</h1><p>Войдите, чтобы увидеть историю заказов.</p><button className="order-primary-button" onClick={() => navigate('/profile')}>Войти</button></div></div>;
  if (query.isLoading) return <div className="orders-page"><h1>Мои заказы</h1><p>Загружаем заказы…</p></div>;
  if (query.isError) return <div className="orders-page"><h1>Мои заказы</h1><p className="order-error">{customerOrderError(query.error)}</p><button className="order-secondary-button" onClick={() => query.refetch()}>Повторить</button></div>;
  const orders = Array.isArray(query.data) ? query.data : query.data?.orders || [];
  return <div className="orders-page">
    <div className="orders-heading"><h1>Мои заказы</h1><button className="order-secondary-button" onClick={() => query.refetch()}>Обновить</button></div>
    {!orders.length ? <div className="orders-empty"><p>Заказов пока нет.</p><Link to="/" className="order-primary-button">Перейти в каталог</Link></div> : <div className="order-list">{orders.map((order) => {
      const items = getOrderItems(order);
      return <article className="order-card" key={getOrderId(order)}>
        <div className="order-card-top">
          <strong>{orderDate(order)}</strong>
          <span className="status-badge">{customerOrderStatusLabel(order.status)}</span>
        </div>
        <div className="order-card-meta"><span>Сумма: <b>{orderGrandTotal(order)} ₽</b></span></div>
        {items.length ? <OrderProductList items={items} limit={3} /> : <p>Состав заказа уточняется</p>}
        <Link className="order-primary-button" to={`/orders/${getOrderId(order)}`} state={{ order }}>Подробнее</Link>
      </article>;
    })}</div>}
  </div>;
}
export default CustomerOrdersPage;
